module.exports = __webpack_public_path__ + "static/media/get-in-applestore.2928664f.svg";